export default "__VITE_ASSET__uarQin_C__"